<template>
  <div>
    <div v-if="loadingPdf" class="loading-modal">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <h5>Selecione um período para gerar o PDF:</h5>
    <div class="input-semestre-box">
      

      <CenarioInput
        placeholder="Escolha o ano"
        nome="ano"
        class="input-semestre"
        :model="ano"
        :options="anosDisponiveis"
        @update:model="update => (ano = update)"
        @selected="update => (ano = update)"
      />
      <CenarioInput
        placeholder="Escolha o Semestre"
        nome="semestre"
        class="input-semestre-ano"
        :model="semestre"
        :disabled="ano == '' || ano == 'Todos os anos' ? true : false"
        :options="semestresDisponiveis"
        @update:model="update => (semestre = update)"
        @selected="update => (semestre = update)"
      />
    </div>

    <div v-if="blFiltros" class="filtros">
      <h5>FILTROS SELECIONADOS:</h5>
      <div>
        <h5>Produto:</h5>
        <p>{{ form && form.nome_produto ? form.nome_produto : "Não Informado" }}</p>
      </div>
      <div class="filtros-box">
        <div>
          <h5>NCM:</h5>
          <p>{{ form && form.ncm ? form.ncm : "Não Informado" }}</p>
        </div>
        <div>
          <h5>UF:</h5>
          <p>{{ form && form.uf ? form.uf : "Não Informado" }}</p>
        </div>
        <div>
          <h5>TRIBUTO:</h5>
          <p>{{ form && form.tributo ? form.tributo : "Não Informado" }}</p>
        </div>
      </div>
    </div>
    <div v-else class="filtros">
      <h5>FILTROS SELECIONADOS:</h5>
      <div>
        <p>Não há filtros selecionados</p>
      </div>
    </div>
    <h5 class="total">Total de Alterações: {{ filteredAlteracoes.length }}</h5>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "ModalRelatorioPdf",
  components: { CenarioInput, BotaoPadrao },
  inject: ["pushAlert"],
  data() {
    return {
      semestreOptions: ["1º Semestre", "2º Semestre"],
      semestre: "",
      ano: "",
      loadingPdf: false,
      blButtonOk: true
    };
  },
  props: {
    form: Object,
    voltar: Boolean,
    blOptions:Boolean,
    alteracoes: Array
  },
  watch: {
    blOptions(){
      if(this.blOptions ==true){
        this.limparModal();
      }
    },
    voltar(newValue, oldValue) {
      this.limparModal();
    },
    ano() {
      if (this.ano == "") {
        this.semestre = "";
      }
    },
    filteredAlteracoes() {
      this.$emit("produtosFiltradosAtualizados", this.filteredAlteracoes);
      this.$emit("filtrosUtilizados", { ano: this.ano, semestre: this.semestre });
    },
    loadingPdf() {
      if (this.loadingPdf == true) {
        this.blButtonOk = true;
      }
    }
  },
  computed: {
    blFiltros() {
      if(this.form){
        let preenchido = false;
      Object.values(this.form).forEach(value => {
        if (value !== "") {
          preenchido = true;
        }
      });
      return preenchido;
      }

    },

    anosDisponiveis() {
      const anos = new Set();
      if (this.alteracoes) {
        if (this.alteracoes.length <= 500) {
          anos.add("Todos os anos");
        }
        this.alteracoes.forEach(produto => {
          const dataFormatada = produto.data_alteracao
            .split("/")
            .reverse()
            .join("-");
          const ano = new Date(dataFormatada).getFullYear();
          anos.add(`${ano}`);
        });
      }
      return Array.from(anos);
    },
    semestresDisponiveis() {
      const semestres = new Set();
      if (this.alteracoes) {
        this.alteracoes.forEach(produto => {
          const [dia, mes, ano] = produto.data_alteracao.split("/");
          const dataFormatada = `${mes}/${dia}/${ano}`;
          const data = new Date(dataFormatada);
          const anoCalendario = data.getFullYear();
          const semestre = data.getMonth() >= 6 ? 2 : 1;
          if (this.ano && this.ano.toString() === anoCalendario.toString()) {
            semestres.add(`${semestre}º Semestre`);
          }
        });
      }
      return Array.from(semestres).sort();
    },
    filteredAlteracoes() {
      if (this.ano === "Todos os anos") {
        return this.alteracoes;
      }
      if (!this.alteracoes || !this.ano || !this.semestre) {
        return [];
      }

      const semestreString = this.semestre;

      return this.alteracoes.filter(alteracao => {
        const [dia, mes, ano] = alteracao.data_alteracao.split("/");
        const alteracaoSemestre = `${mes >= 7 ? 2 : 1}º Semestre`;
        return alteracaoSemestre === semestreString && ano === this.ano;
      });
    }
  },
  methods: {
    limparModal() {
      (this.semestre = ""), (this.ano = "");
    }
  }
};
</script>
<style>
.loading-modal {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #9e9e9ea8;
  left: 0;
  top: 0;
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  color: var(--branco);
}
.filtros {
  border: 2px solid var(--cinza03);
  border-radius: 2px;
  padding: 10px;
}
.filtros-box {
  display: flex;
  justify-content: space-between;
}
.input-semestre-box {
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
}
.input-semestre {
  padding-right: 15px;
}
.input-semestre-ano {
  padding-left: 15px;
}
h5 {
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
}
p {
  font-size: 13px;
}
.total {
  margin: 10px 0;
}
</style>
